module.exports = __webpack_public_path__ + "img/img_26.b3617d34.png";